import React from "react";
import HomePage from "../pages/lemonbaby/home_page";
import AppRoutes from "../routes";
import Header from "../components/fitbae/layouts/header";
import Footer from "../components/fitbae/layouts/footer";

const LemonBabyTemplate = () => {
  return (
    <React.Fragment>
      <div className="flex flex-col min-h-screen">
        {/* <Header /> */}
        <AppRoutes homePage={HomePage} />
        <div className="mt-auto">{/* <Footer /> */}</div>
      </div>
    </React.Fragment>
  );
};

export default LemonBabyTemplate;
